import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;

  .payment-history-toolbar {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
    padding: ${spacing(4)} ${spacing(6)};
    border-bottom: 1px solid ${base_colorContentBorder};

    > :first-child {
      flex: 1;
      max-width: 420px;
    }
  }

  .payment-history-status-menu {
    display: flex;
    min-width: 210px;
    padding: ${spacing(3)} 0;
    flex-direction: column;
    background: white;

    label {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};
      padding: ${spacing(2)} ${spacing(5)};
      color: ${text_colorTextPrimary};
      cursor: pointer;
    }
  }

  .payment-history-grid {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .payment-history-invoice-error {
    padding: ${spacing(3)} ${spacing(6)};
    border-bottom: 1px solid ${base_colorContentBorder};
    color: ${text_colorTextPrimary};
    background: ${base_colorSurfaceSecondary};
    ${font_md};
  }

  .payment-invoice-button {
    display: inline-flex;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .payment-history-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${spacing(5)};
    min-height: 56px;
    padding: 0 ${spacing(6)};
    border-top: 1px solid ${base_colorContentBorder};
    color: ${text_colorTextSecondary};
    ${font_md};

    button {
      border: 0;
      background: transparent;
      color: ${text_colorTextPrimary};
      font-size: 22px;
      cursor: pointer;
    }

    button:disabled {
      opacity: 0.35;
      cursor: default;
    }
  }

  .payment-history-message,
  .payment-history-empty {
    display: flex;
    flex: 1;
    min-height: 360px;
    align-items: center;
    justify-content: center;
    color: ${text_colorTextSecondary};
  }

  .payment-history-message {
    flex-direction: column;
    gap: ${spacing(4)};
  }

  .payment-history-empty {
    flex-direction: column;
    gap: ${spacing(3)};
    padding: ${spacing(12)} ${spacing(6)};
    text-align: center;

    h2 {
      margin: 0;
      font-size: 20px;
      line-height: 24px;
      font-family: ${font_family_weight_medium};
      color: ${text_colorTextPrimary};
    }

    p {
      max-width: 470px;
      margin: 0;
      ${font_md};
      color: ${text_colorTextSecondary};
    }
  }

  .payment-history-empty-icon {
    display: flex;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${base_colorSurfaceSecondary};

    svg {
      width: 28px;
      height: 28px;
    }
  }

  .payment-history-empty-actions {
    display: flex;
    gap: ${spacing(4)};
    margin-top: ${spacing(2)};
  }
`
